/**
 * Created by shobhitjain on 07/05/20.
 */

import React from 'react';
import { orderBy } from 'lodash';
import style from './index.scss';
import moment from 'moment';
import classnames from 'classnames';
import { dateFormat_DD_MM_YY, dateTimeFormat } from '../../util/GlobalConstant';
import { putHyphenIfEmpty } from '../../services/util';

export const CustomerInformationRow = ({ title, label, crsVersion }) => {
  return (
    <div
      className={
        crsVersion ? style.label_value_wrapper_crs : style.label_value_wrapper
      }>
      <label>{label}</label>
      <p style={{ wordBreak: 'break-all' }} title={title}>
        {title}
      </p>
    </div>
  );
};

export const HighRiskPartyLabel = ({ crsVersion }) => {
  return (
    <div className={style.label_value_wrapper}>
      <label
        style={{ flexBasis: '100%', fontSize: 14, marginBottom: 15 }}
        className={
          crsVersion ? style.label_value_wrapper_crs : style.label_value_wrapper
        }>
        High Risk Party Information
      </label>
    </div>
  );
};

export const HighRiskPartyInformation = ({ highRiskPartyInfo }) => {
  if (highRiskPartyInfo) {
    try {
      const { expiration_date, predefined_comments } = JSON.parse(
        highRiskPartyInfo.trim()
      );
      return (
        <div>
          <p style={{ fontSize: 14, marginBottom: 5, color: '#9dc5e9' }}>
            High Risk Party Information
          </p>
          <div className="row">
            <div className="col-md-5">
              <p style={{ marginBottom: 5 }}>
                <span style={{ marginLeft: '10px', color: '#9dc5e9' }}>
                  Expiration Date
                </span>
              </p>
              <p>
                <span style={{ marginLeft: '10px', color: '#9dc5e9' }}>
                  Predefined Comments
                </span>
              </p>
            </div>
            <div className="col-md-6">
              <p style={{ marginBottom: 5 }}>
                <span style={{ marginLeft: '10px' }}>
                  {expiration_date
                    ? moment
                        .utc(expiration_date, [dateTimeFormat])
                        .local()
                        .format('DD/MM/YYYY')
                    : '-'}
                </span>
              </p>
              <p>
                <span style={{ marginLeft: '10px' }}>
                  {predefined_comments ? predefined_comments : '-'}
                </span>
              </p>
            </div>
          </div>
        </div>
      );
    } catch (err) {
      console.log('err', err);
    }
  }

  return (
    <div>
      <p style={{ fontSize: 14, marginBottom: 5, color: '#9dc5e9' }}>
        High Risk Party Information
      </p>
      <div className="row">
        <div className="col-md-5">
          <p style={{ marginBottom: 5 }}>
            <span style={{ marginLeft: '10px', color: '#9dc5e9' }}>
              Expiration Date
            </span>
          </p>
          <p>
            <span style={{ marginLeft: '10px', color: '#9dc5e9' }}>
              Predefined Comments
            </span>
          </p>
        </div>
        <div className="col-md-6">
          <p style={{ marginBottom: 5 }}>
            <span style={{ marginLeft: '10px' }}>-</span>
          </p>
          <p>
            <span style={{ marginLeft: '10px' }}>-</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export const RiskRatingComponent = ({
  riskRatingObject,
  crsVersion,
  label
}) => {
  return (
    <div
      className={
        crsVersion ? style.label_value_wrapper_crs : style.label_value_wrapper
      }>
      <label>{label ? label : 'Risk Rating'}</label>
      <p title={riskRatingObject.label}>
        <span className={classnames(style.risk_status, riskRatingObject.style)}>
          {riskRatingObject.label}
        </span>
      </p>
    </div>
  );
};

const CustomerProfileViewComponent = (props) => {
  const { profileConf, customerProfile, crsVersion } = props;
  return (
    <div className="card-body details-section">
      <div className="row">
        {profileConf.map((column, key) => {
          const sortedColumn = orderBy(column, ['priority'], ['asc']);
          return (
            <div
              className={classnames(
                `col-sm-${profileConf.length === 3 ? 4 : 3}`,
                crsVersion ? style.crs_border_col : ''
              )}
              key={key}>
              {sortedColumn.map((row, idx) => {
                const {
                  supportingParam,
                  label,
                  attribute,
                  isFormattedFunc,
                  isCustomFunc,
                  isCustomRenderer
                } = row;
                const value = putHyphenIfEmpty(customerProfile[attribute]);
                if (isCustomRenderer) {
                  if (row?.attribute === 'riskRating') {
                    const label = row?.label;
                    return (
                      <span key={attribute + idx}>
                        {row.customRenderer(value, label)}
                      </span>
                    );
                  }

                  return (
                    <span key={attribute + idx}>
                      {row.customRenderer(value)}
                    </span>
                  );
                } else if (isCustomFunc) {
                  if (
                    row?.attribute === 'isStaff' ||
                    row?.attribute === 'pepInd'
                  ) {
                    return (
                      <CustomerInformationRow
                        title={row.customFunction(customerProfile[attribute])}
                        label={label}
                        crsVersion={crsVersion}
                        key={attribute + idx}
                      />
                    );
                  }
                  return (
                    <CustomerInformationRow
                      title={row.customFunction(value)}
                      label={label}
                      crsVersion={crsVersion}
                      key={attribute + idx}
                    />
                  );
                } else if (isFormattedFunc) {
                  return (
                    <CustomerInformationRow
                      title={row.formatterFunc(
                        value,
                        supportingParam ? dateFormat_DD_MM_YY : supportingParam
                      )}
                      label={label}
                      crsVersion={crsVersion}
                      key={attribute + idx}
                    />
                  );
                } else {
                  return (
                    <CustomerInformationRow
                      title={value}
                      label={label}
                      crsVersion={crsVersion}
                      key={attribute + idx}
                    />
                  );
                }
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CustomerProfileViewComponent;
